sizeCols = function() {
    var e = window.innerWidth,
        t = $(".cols"),
        i = $(".cols .col");
    if (t)
        if (768 >= e) i.height("auto");
        else
            for (var o = 0; o < t.length; o++) {
                var a = 0;
                $(t[o]).find(i).height("auto"), $(t[o]).find(i).each(function() {
                    $(this).height("auto").height() > a && (a = $(this).height())
                }), $(t[o]).find(i).height(a)
            }
}, mobileSlider = function() {
    var e = window.innerWidth,
        t = $(".ingredients-mobile .slick-initialized").length;
    1 > t && 768 >= e && $(".ingredients-mobile .ingredients-grid").first().slick({
        autoplay: !1,
        arrows: !0,
        infinite: !0,
        slidesToShow: 1,
        slidesToScroll: 1,
        slide: "div.slide-item",
        prevArrow: ".ingredients-mobile .prev-arrow",
        nextArrow: ".ingredients-mobile .next-arrow"
    })
}, subscriptionsSelect = function() {
    var e = $(".subscription-options");
    e.on("click", ".option-box", function() {
        var e = $(this),
            t = $(".option-box"),
            i = e.attr("data-handle"),
            o = e.attr("data-productmainid"),
            a = $(".p" + o + ' input[type="radio"]'),
            r = e.find(".product-info").attr("data-productid"),
            n = $(".extra-copy-inner"),
            s = $(".extra-copy"),
            d = $("#extra-" + i);
      
      
      
      $('#product-affiliate .product-single__photos img').attr("src", e.data('imgurl'));
      //console.log(e.data('imgurl'));
      
      
        t.removeClass("selected"), e.addClass("selected"), s.removeClass("opacity"), d.length > 0 ? n.hasClass("opened") ? (s.removeClass("show"), d.addClass("show"), d.addClass("opacity")) : (s.removeClass("show"), d.addClass("show"), d.addClass("opacity"), n.addClass("opened")) : (s.removeClass("show"), n.removeClass("opened")), a.prop("checked", !0), $("#productSelect").val(r)
    })
}, removeProperties = function(e) {
    e.find(".product-bottom").find(".frequency_type_text").removeAttr("name"), e.find(".product-bottom").find(".group_id").removeAttr("name"), e.find(".product-bottom").find(".frequency_num").removeAttr("name"), e.find(".product-bottom").find(".frequency_type").removeAttr("name"), e.find(".product-bottom").find(".discounted_price").removeAttr("name"), e.find(".product-bottom").find(".prepaid_checkbox").removeAttr("name"), e.find(".product-bottom").find(".prepaid_length_select").removeAttr("name"), e.find(".product-bottom").find(".ro_unformatted_price").removeAttr("name"), e.find(".product-bottom").find(".ro_discount_percentage").removeAttr("name")
}, subscriptions = function() {
    var e = $("#AddToCartForm"),
        t = $("#AddToCart"),
        i = $(".bag #CartCount"),
        o = $("[data-remodal-id=product-added]").remodal();
    t.on("click", function(t) {
        t.preventDefault(), removeProperties(e);
        var a = parseInt($("input#Quantity").val()),
            r = $(".option-box.selected"),
            n = r.find(".option-title").text(),
            s = r.find(".product-info"),
            d = s.attr("data-productid"),
            l = s.attr("data-producturl"),
            url = r.data("imgurl"),
            c = "<span class='money'>$ " + (parseInt(s.attr("data-productprice")) * a / 100).toFixed(2) + "</span>",
            p = s.find(".supply-info .supply-time").text(), 
            v = s.find(".supply-info .supply-amount").text(),
            u = parseInt(i.text()) + a,
            f = $("#AddToCart"),
            m = $("#AddToCartText"),
            b = $("[data-remodal-id=product-added] #added-variant"),
            h = $("[data-remodal-id=product-added] #added-quantity"),
            g = $("[data-remodal-id=product-added] #added-price"),
            m_img = $("[data-remodal-id=product-added] .added-img img"),
            pills_pouch = $("input.line_item_prop").val();
            if(pills_pouch != null && pills_pouch != ''){
             var C = {  
                Pouches: pills_pouch,
                url: l       
             };
            }else{
              
              if(v != null && v!=''){
              	var C = {
                	Details: p + ", " + v,
                	url: l
              	};
              }else{
              	var C = {
                	Details: p,
                	url: l
              	};
              }

            }
            
        if (r.next(".product_rp_div").length > 0) var y = r.next(".product_rp_div");
        else if (r.next("form").find(".product_rp_div").length > 0) var y = r.next("form").find(".product_rp_div");
        if (void 0 !== y) {
            var w = parseInt(y.attr("data-groupid")),
                x = y.find(".frequency_div"),
                _ = x.find(".frequency_num").val(),
                k = x.find(".frequency_type").val();
            if (x.find(".limited_length_div")) {
                var A = x.find(".limited_length_div").find(".limited_length_select").val();
                C.limited_length_select = A
            }
            _ && (C.frequency_num = _, C.frequency_type = k, C.group_id = w)
        }
        $.post("/cart/add.js", {
            quantity: a,
            id: d,
            properties: C
        }).fail(function(e, t, r) {
            200 == e.status && (i.text(u), m.text("Added to Cart!"), f.addClass("flash"), b.text(n), h.text(a), g.html(c), m_img.attr('src', url), o && o.open(), setTimeout(function() {
                m.text("Add to Cart"), f.removeClass("flash")
                ajaxCart.load();
                timber.RightDrawer.open();
                if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
                    typeof BOLD.common.eventEmitter.emit === 'function' && BOLDCURRENCY.currentCurrency ){
                  BOLD.common.eventEmitter.emit('BOLD_CURRENCY_double_check');
                }
            }, 1200))
        })
    })
}, subscriptionsPage = function() {
    if ("subscriptions" == $("body").attr("id")) {
        var e = $("#subscription-options"),
            t = $("#confirmation"),
            i = $(".info-cols"),
            o = $("#box-image img"),
            a = $("#product-title"),
            r = e.offset().top,
            n = t.offset().top;
        $(".collection-image").on("click", function() {
            var s = $(this),
                d = s.attr("data-id");
            s.attr("data-handle");
            $(".collection-image, .option-box").removeClass("selected"), e.removeClass("visible opacity"), t.removeClass("visible opacity"), i.removeClass("visible opacity"), s.addClass("selected"), $("#AddToCart").prop("disabled", !0);
            var c = $("#options-" + d),
                p = $("#subscriptions-copy-" + d);
            $(".options-row, .subscriptions-extra-copy").removeClass("show-row"), c.addClass("show-row"), p.addClass("show-row"), e.addClass("visible"), r = e.offset().top, $("html, body").animate({
                scrollTop: r
            }, 400, function() {
                e.addClass("opacity")
            }), $("body").on("click", ".option-box", function() {
                t.removeClass("visible opacity"), i.removeClass("visible opacity"), $("#AddToCart").prop("disabled", !1)
            }), $("body").on("click", "#AddToCart", function() {
                var e = $(".option-box.selected").attr("data-imgurl"),
                    r = $(".option-box.selected").attr("data-title");
                o.attr("src", e), a.text(r), t.addClass("visible"), n = t.offset().top, $("html, body").animate({
                    scrollTop: n
                }, 400, function() {
                    t.addClass("opacity"), i.addClass("visible opacity"), sizeCols()
                })
            })
        })
    }
};
var waitForFinalEvent = function() {
    var e = {};
    return function(t, i, o) {
        o || (o = "defaultId"), e[o] && clearTimeout(e[o]), e[o] = setTimeout(t, i)
    }
}();
$(document).ready(function() {
    $("body").on("click", function(e) {
        var t = $(e.target);
        t.is("header .icon-search") || t.is(".search-btn") || t.is(".icon-search-text") || t.is(".search-input") || t.is(".mobile-search-close") || t.is(".mobile-search-icon") || ($("header .search-site").removeClass("open"), $("#mobile-search").removeClass("open")), t.is(".about-link") || $("#mobile--nav").removeClass("about-open")
    }), $(".mobile--nav").on("click", ".about-link", function() {
        $("#mobile--nav").hasClass("about-open") ? $("#mobile--nav").removeClass("about-open") : $("#mobile--nav").addClass("about-open")
    }), $(".mobile-search-icon, .mobile-search-close").on("click", function() {
        $("#mobile-search").toggleClass("open")
    }),$(".top-menu-bar form.search-site input").on("click", function() {
        $(".search-site").toggleClass("opened")
    }), $(".ingredients-lg").slick({
        autoplay: !1,
        dots: !0,
        arrows: !0,
        infinite: !0,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: !0,
        slide: "div.ingredients-grid",
        prevArrow: ".ingredients-lg .prev-arrow",
        nextArrow: ".ingredients-lg .next-arrow",
        customPaging: function(e, t) {
            var i = $(e.$slides[t]).data("packette-img"),
                o = $(e.$slides[t]).data("packette-name"),
                a = $(e.$slides[t]).data("packette-handle");
            return '<a><div class="packette ' + a + '" data-formula="' + a + '"><img src="' + i + '"><h3>' + o + "</h3></div></a>"
        }
    }), $(".slick-dots").appendTo("#pager-lg"), $("#sustainability").on("click", ".packette", function() {
        var e = $(this).data("formula"),
            t = $(".ingredients-mobile .grid-" + e),
            i = $(".ingredients-mobile .slick-initialized"),
            o = $(".ingredients-mobile .grid-" + i.data("packette-handle"));
        i.slick("unslick"), o.hide(), t.show(), t.slick({
            autoplay: !1,
            arrows: !0,
            infinite: !0,
            slidesToShow: 1,
            slidesToScroll: 1,
            slide: "div.slide-item",
            prevArrow: ".ingredients-mobile .prev-arrow",
            nextArrow: ".ingredients-mobile .next-arrow"
        })
    }), mobileSlider(), sizeCols(), $(window).on("resize", function() {
        $("header .search-site").removeClass("open"), $("#mobile-search").removeClass("open"), waitForFinalEvent(function() {
            mobileSlider()
        }, 500, "mobileSlider"), waitForFinalEvent(function() {
            sizeCols()
        }, 500, "sizeCols")
    }), $(window).on("load", function() {
        subscriptionsSelect(), subscriptions()
    }), subscriptionsPage()
});

$(document).on("stamped:reviews:loaded", function() {
        $(".stamped-summary-actions-newreview").attr("onclick", ""),
            $(".stamped-form-input-textarea ").attr("placeholder", "Write your comments here"),
            $(".stamped-form-input-textarea ").attr("maxlength", "1500")
    }),
    $(document).on("click", ".stamped-summary-actions-newreview", function(a) {
        console.log($(".new-review-form").css("display"));
        "block" == $(".new-review-form").css("display") ?
            $(".new-review-form").hide() :
            $(".new-review-form").show(), a.stopPropagation(), a.preventDefault()
    }),
    $(document).on("click", '.new-review-form input[type="submit"]', function() {
        $('input[name="reviewRating"]').val() || $('.stamped-form-label[for="review_rating"]').text("Rating (required)").css("color", "red")
    });

//code to set redirect URL to sample page after login
var url = window.location.href
if (url.indexOf("=") > 0) {

    var redirect = url.substring(url.indexOf("=") + 1);

    if (redirect) {
        $('input[name=checkout_url]').val(redirect);
    }
}